import { Icon, Input, Table, Modal } from 'antd';
import update from 'immutability-helper';
import React, { useCallback, useEffect, useState } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { deleteResposta, getAllPerguntaComResposta, Pergunta } from '../../../api/minuta/Pergunta';
import {
  getAllRespostaByPerguntaId,
  putAtualizarDescricaoResposta,
  Resposta,
  UpdateManyResposta,
} from '../../../api/minuta/Resposta';
import { componentsSorting } from '../../../components/SortingTable';

const { confirm } = Modal;
interface TabelaRespostaProps {
  perguntaResult: Pergunta;
  atualizarListaPergunta: () => void;
}

const TabelaResposta = (props: TabelaRespostaProps) => {
  const { perguntaResult, atualizarListaPergunta } = props;
  const [pergunta, setPergunta] = useState<Pergunta>(perguntaResult);

  useEffect(() => {
    setPergunta(perguntaResult);
  }, [perguntaResult]);

  const definirItemEditavel = (respostaId: string) => {
    if (pergunta && pergunta.respostas.length > 0) {
      const respostaResult = pergunta.respostas.map(respota => {
        if (respota.id === respostaId) {
          respota.editavel = true;
        } else {
          respota.editavel = false;
        }
        return respota;
      });
      setPergunta({ ...pergunta, respostas: respostaResult } as Pergunta);
    }
  };

  const updateResposta = (record: Resposta, desricao: string) => {
    if (pergunta) {
      const novaResposta = {
        perguntaId: pergunta.id,
        id: record.id,
        descricao: desricao,
      } as Resposta;

      putAtualizarDescricaoResposta(novaResposta).then(data => {
        if (data) {
          getAllRespostaByPerguntaId(novaResposta.perguntaId).then(result => {
            setPergunta({ ...pergunta, respostas: result } as Pergunta);
          });
        }
      });
    }
  };

  const onDelete = async (id: string, idPergunta: string) => {
    const respDelete = await deleteResposta(id);

    if (respDelete) {
      const dataAll = await getAllPerguntaComResposta();
      if (dataAll) {
        const pergunta = dataAll.find(d => {
          if (d.id === idPergunta) {
            return d;
          }
        });

        pergunta && setPergunta(pergunta);

        atualizarListaPergunta();
      }
    }
  };

  const collunsResposta = [
    {
      title: 'Ordem',
      dataIndex: 'ordem',
      width: '5%',
      key: 'ordem',
    },
    {
      title: 'Resposta',
      dataIndex: 'descricao',
      width: '90%',
      key: 'descricao',
      render: (index: any, record: any, rowKey: any) => {
        if (record.editavel != true) {
          return (
            <div
              onClick={() => {
                definirItemEditavel(record.id);
              }}>
              {record.descricao}
            </div>
          );
        }
        return (
          <>
            <Input
              name={`editDescicao${record.id}`}
              onPressEnter={e => {
                if (e) {
                  const descricaoAlterada = e.target.value;
                  updateResposta(record, descricaoAlterada);
                  atualizarListaPergunta();
                }
              }}
              defaultValue={record.descricao}
              ref={node => { }}
              onBlur={e => {
                if (e) {
                  const descricaoAlterada = e.target.value;
                  updateResposta(record, descricaoAlterada);
                  atualizarListaPergunta();
                }
              }}
            />
          </>
        );
      },
    },
    {
      title: 'Ações',
      isDummyField: true,
      width: '5%',
      dataIndex: 'acoes',
      key: 'acoes',
      render: (index: any, record: any, rowkey: any) => {
        return [
          <>
            <Icon
              key="delete"
              type="delete"
              onClick={() => {
                confirm({
                  title: 'Deseja realmente apagar a resposta?',
                  icon: <Icon type="info-circle" />,
                  okText: 'Sim',
                  cancelText: 'Não',
                  onOk: async () => {
                    onDelete(record.id, record.perguntaId);
                    return;
                  },
                  onCancel() {
                    return;
                  },
                });
              }}
            />
          </>,
        ];
      },
    },
  ];

  const moveRow = useCallback(
    (dragIndex, hoverIndex) => {
      const dragRow = pergunta.respostas[dragIndex];
      const respUpdate = update(pergunta.respostas, {
        $splice: [
          [dragIndex, 1],
          [hoverIndex, 0, dragRow],
        ],
      });

      const ordem = respUpdate.map((ru, index) => {
        return { ...ru, ordem: index + 1, Descricao: respUpdate[index].descricao };
      });
      UpdateManyResposta({ respostas: ordem }).then(() => {
        atualizarListaPergunta();
        getAllRespostaByPerguntaId(pergunta.id).then(data => {
          if (data) setPergunta({ ...pergunta, respostas: data });
        });
      });
    },
    [pergunta],
  );

  return (
    <>
      <DndProvider backend={HTML5Backend}>
        <Table
          rowKey="id"
          dataSource={pergunta.respostas}
          columns={collunsResposta}
          components={componentsSorting}
          onRow={(record, index) => ({
            index,
            moveRow,
          })}
          pagination={false}
        />
      </DndProvider>
    </>
  );
};

export default TabelaResposta;
